import loadImages from '../../libs/loadImages';

import pipeEnd from '../../../images/bulging-production-pipe.png';

const imagesToLoad = {
  pipeEnd,
};

const images = loadImages(imagesToLoad);

export default images;
